import type { WeatherViewModel } from '../weather/weather-types.js';
import { formatInMendoza } from '../weather/format.js';
import { wmoLabelEs } from '../weather/wmo-labels.js';
import { UI } from '../ui-strings.js';

export function PanelWeather({ weather }: { weather: WeatherViewModel }) {
  if (weather.status === 'unavailable' || !weather.bundle) {
    return (
      <div className="cl-panel">
        <h3>{UI.panelWeather}</h3>
        <p style={{ marginTop: 8 }}>{UI.weatherUnavailable}</p>
        {weather.errorMessage ? <p style={{ opacity: 0.8, fontSize: '0.82rem' }}>{weather.errorMessage}</p> : null}
      </div>
    );
  }

  const b = weather.bundle;
  const cur = b.current;
  const updated = formatInMendoza(b.fetchedAt, {
    dateStyle: 'short',
    timeStyle: 'short',
  });

  return (
    <div className="cl-panel cl-panel-weather">
      <h3>{UI.panelWeather}</h3>
      <p className="cl-weather-loc">{b.locationLabel}</p>
      <p className="cl-weather-main">
        <strong>{Math.round(cur.temperatureC)}°C</strong> · {wmoLabelEs(cur.weatherCode)}
      </p>
      <ul className="cl-weather-stats">
        <li>{UI.feelsLike}: {Math.round(cur.apparentTemperatureC)}°C</li>
        <li>{UI.rainChance}: {b.hourly[0]?.precipitationProbabilityPct ?? '—'}%</li>
        <li>{UI.wind}: {Math.round(cur.windSpeedKmh)} km/h</li>
      </ul>
      <h4 className="cl-weather-sub">{UI.hourlyForecast}</h4>
      <ul className="cl-weather-hourly">
        {b.hourly.slice(0, 8).map((h) => (
          <li key={h.time}>
            {formatInMendoza(h.time, { hour: '2-digit', minute: '2-digit' })} — {Math.round(h.temperatureC)}°C ·{' '}
            {h.precipitationProbabilityPct}% · {wmoLabelEs(h.weatherCode)}
          </li>
        ))}
      </ul>
      <h4 className="cl-weather-sub">{UI.dailyForecast}</h4>
      <ul className="cl-weather-daily">
        {b.daily.map((d) => (
          <li key={d.date}>
            {formatInMendoza(d.date, { weekday: 'short', day: 'numeric', month: 'short' })} —{' '}
            {Math.round(d.tempMinC)}° / {Math.round(d.tempMaxC)}°C · {d.precipitationProbabilityMaxPct}% ·{' '}
            {wmoLabelEs(d.weatherCode)}
          </li>
        ))}
      </ul>
      <p className="cl-weather-meta">
        {UI.updated}: {updated}
        {weather.status === 'stale' && weather.ageMinutes != null ? ` (${UI.staleData}, ${weather.ageMinutes} min)` : ''}
        <br />
        {UI.source}: {b.source}
      </p>
    </div>
  );
}
